export const users = (state = [], action) => {
  if (action.type === 'FETCH_USERS') {
    return action.payload;
  }
  if (action.type === 'CLEAR_USERS') {
    return [];
  }
  return state;
};

export const user = (state = {}, action) => {
  if (action.type === 'FETCH_USER') {
    return action.payload;
  }
  if (action.type === 'CLEAR_USER') {
    return {};
  }
  return state;
};
